const initialState = {
  editing: false,
  disputeModalActive: false,
  clientModalActive: false,
  releasing: false,
  canceling: false,
  hasSellPayments: false,
  accounts: [
    'Charlie',
    'Nhan',
    'Alex',
    'Other',
  ],
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case 'TOGGLE_TRADE_EDIT': {
      return {
        ...state,
        editing: !state.editing,
      };
    }
    case 'SET_SELL_CHANNELS': {
      return {
        ...state,
        hasSellPayments: payload.channels.length > 0,
      };
    }
    case 'TRADE_UPDATED': {
      return {
        ...state,
        editing: false,
      };
    }
    case 'TRADE_RELEASING_FUNDS': {
      return {
        ...state,
        releasing: true,
      };
    }
    case 'TRADE_CANCELING': {
      return {
        ...state,
        canceling: true,
      };
    }
    case 'TOGGLE_DISPUTE_MODAL': {
      const { active } = payload;
      return {
        ...state,
        disputeModalActive: active,
      };
    }
    case 'TOGGLE_CLIENT_MODAL': {
      const { active } = payload;
      return {
        ...state,
        clientModalActive: active,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/TradeDetails.reducer.js